import { useModalStore } from '@/shared/ui/AppModal/store/modal';
import type {
  ModalName,
  OpenedModals,
  UseOpenedModalsReturn,
} from '@/shared/model/types/useOpenedModals';

const PREFETCH_FALLBACK_DELAY = 2000;

export const useOpenedModals = (
  names: readonly ModalName[],
  prefetch?: () => void,
): UseOpenedModalsReturn => {
  const { modalState } = storeToRefs(useModalStore());
  const openedModals: Ref<OpenedModals> = ref({});

  names.forEach((name) => {
    openedModals.value[name] = false;

    watch(
      () => modalState.value[name],
      (isOpen) => {
        if (isOpen) openedModals.value[name] = true;
      },
      { immediate: true },
    );
  });

  onMounted(() => {
    if (!prefetch) return;

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(prefetch);
    } else {
      setTimeout(prefetch, PREFETCH_FALLBACK_DELAY);
    }
  });

  return { openedModals };
};
